<template>
  <v-card class="pa-4">
    <div class="text-center">
      <h2>Editar cliente</h2>
    </div>

    <v-form ref="form">
      <v-row class="ma-0">
        <v-col cols="12" sm="6">
          <label>Nome do cliente:</label>
          <v-text-field
            v-model="client.name"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            outlined
            style="border: 1px solid #979797; border-radius: 7.5px"
            background-color="#F5F5F5"
            hide-details
            color="black"
            required
            placeholder="nome do cliente"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <label>Sobrenome do cliente:</label>
          <v-text-field
            v-model="client.surname"
            outlined
            style="border: 1px solid #979797; border-radius: 7.5px"
            background-color="#F5F5F5"
            hide-details
            color="black"
            required
            placeholder="sobrenome do cliente"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <label>E-mail do cliente:</label>
          <v-text-field
            v-model="client.email"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            outlined
            style="border: 1px solid #979797; border-radius: 7.5px"
            background-color="#F5F5F5"
            hide-details
            color="black"
            required
            placeholder="nome do e-mail"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <label>Telefone do cliente:</label>
          <v-text-field
            v-model="client.phoneNumber"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            outlined
            style="border: 1px solid #979797; border-radius: 7.5px"
            background-color="#F5F5F5"
            hide-details
            color="black"
            required
            placeholder="número de telefone"
          ></v-text-field>
        </v-col>

        <v-col>
          <label>Data do cadastro:</label>
          <v-text-field
            disabled
            v-model="client.created_at"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            outlined
            type="date"
            style="border: 1px solid #979797; border-radius: 7.5px"
            background-color="#F5F5F5"
            hide-details
            color="black"
            required
            placeholder="data de cadastro"
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn class="primary-button ma-0" @click="submit" :loading="loading"
            >Salvar</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
export default {
  name: "ManagePage",

  props: {
    clientProp: {},
  },

  created() {
    this.client = {
      ...this.clientProp,
      created_at: this.clientProp.created_at
        ? this.clientProp.created_at.split(`T`)[0]
        : ``,
    };
  },

  data() {
    return {
      client: {},
      apiService: new ApiService(),
      loading: false,
    };
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.client.doneByAdminOrMasterUser = true;
        this.apiService
          .put(`client/editprofile`, this.client)
          .then((response) => {
            this.loading = false;
            this.$toast.success(`Cliente atualizado com sucesso!`);
            this.$emit(`confirm`);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style></style>
